import React from "react";
import Picture, { PictureProps } from "@soluto-design/picture";
import Video, { VideoProps } from "design-system/src/components/atoms/Video";

type BaseMedia = {
  isImage: boolean;
  alt?: string;
};

export type Image = BaseMedia & PictureProps;

export type Video = BaseMedia & {
  extension: "mp4" | "mov" | "webm";
  height: number;
  width: number;
  src: string;
};

export interface MediaProps extends PictureProps, VideoProps {
  media?: Image | Video;
  alt?: string;
  layout?: "responsive" | "fill";
  placeholderImage?: PictureProps;
}

const Media: React.FC<MediaProps> = ({
  placeholderImage,
  media,
  alt,
  layout = "responsive",
  ...props
}) => {
  return media?.isImage ? (
    <Picture
      layout={layout}
      {...media}
      {...props}
      {...(!!(media?.alt || alt) && { alt: media?.alt || alt })}
    />
  ) : media ? (
    <Video
      layout={layout}
      poster={placeholderImage}
      {...props}
      sources={[
        {
          src: media.src,
          type: (media as Video)?.extension ?? "mp4",
        },
      ]}
    />
  ) : null;
};

export default Media;
